import { render, staticRenderFns } from "./DappDetailedSummary.vue?vue&type=template&id=04e7b36c&scoped=true"
import script from "./DappDetailedSummary.vue?vue&type=script&lang=ts"
export * from "./DappDetailedSummary.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedSummary.vue?vue&type=style&index=0&id=04e7b36c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e7b36c",
  null
  
)

export default component.exports